<template>
    <div class="relative">
           <p class="label_css flex justify-between" v-if="!hideLable">
            <span>{{lableText}}</span>
            <span class="text contents" v-if="showcharLimit">{{inputValue.length}}/{{textMaxlength}}</span>
            </p>
            <input
            :maxlength="textMaxlength"
            @keypress="isNumber($event)"
            @keypress.enter="enterkeyPressAction"  
            @blur="blurAction(inputValue)"
            @input="inputChangeAction(inputValue)"
            @change="change"
            @keyup="keyup"
            :pattern="pattern"
            @click="onClickInputAction"
            @focus="focus"
            v-model="inputValue"
            :disabled="disabled"
            :placeholder="placholderText"
            :readonly="setReadOnly"
            :type="inputTypeText"
            :class="`${inputType === 'color' ? 'h-12 py-0' : ''} ${isSmall ? 'py-1' : 'py-3'} ${showCountry ? 'pl-16':''} ${textRight ? 'text-right pr-2' : ''} ${showError ? 'border border-error text-error' : 'border border-gray2 flex text-text1 focus:border-primary focus:ring-1'}
            pr-${inputType === 'password' || showDate ? '8' : '0'}
            `"
            :autofocus="setAutoFocust"
            autocomplete="off"
            :id="inputId"
            class="cust_text_field  px-2 w-full bg-white rounded items-center">


                <span v-if="inputType === 'password'" @click.stop.prevent="hidePassword = !hidePassword" 
                  :class="lableText !== '' ? 'top-8' : 'top-3' "
                  class="place-self-center absolute  right-3 cursor-pointer mt-0.5">
                    <p v-if="!hidePassword">
                      <i class="fa-solid fa-eye-slash text-gray3 heading-6"></i>
                    </p>
                  <span v-if="hidePassword">
                    <i class="fa-solid fa-eye text-gray3 heading-6"></i>
                  </span>
                </span>
                <span  @click="onClickInputAction" v-if="showDate" 
                  :class="lableText !== '' ? 'top-8' : 'top-3' "
                  class="place-self-center absolute  right-3 cursor-pointer mt-0.5">
                  
                   <i class="fa-solid fa-calendar-days text-gray3 heading-6"></i>
                </span>
                <span @click="onClickInputAction" v-if="showTime" 
                :class="lableText !== '' ? 'top-8' : 'top-3' "
                class="place-self-center absolute  right-3 cursor-pointer mt-0.5">
                   <i class="fa-regular fa-clock heading-3 text-primary"></i>
                </span>
        </div>
</template>
<script>
import Vue from 'vue'
Vue.directive('click-outside-textInput', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
export default {
  components: {
  },
    props: ['hideLable', 'isSmall',  'showCountry', 'showcharLimit', 'pattern', "textRight", "inputext", "textMaxlength", 'lableText', 'inputId', 'autoFocus', 'fieldError', 'setReadOnly', 'placholderText', 'inputType', "showDate", "disabled", "showTime", "selectedCountry"],
  data() {
    return {
      countryList: [],
      countryMainList: [],
      showContrylist: false,
      countryCode: '+1',
      inputTypeText: 'text',
      hidePassword: false,
      showError: false,
      setAutoFocust: false,
      disabledBtn: false,
      searchForCountry: '',
      inputValue: ''
    };
  },
  watch: {
    selectedCountry: {
        handler () {
          this.countryCode = this.selectedCountry
        }
    },
    fieldError: {
        handler () {
          this.showError = this.fieldError
        }
    },
    hidePassword: {
        handler () {
          if (this.hidePassword) {
            this.inputTypeText = 'password'
            document.getElementById(`${this.inputId}`).focus()
          } else {
            this.inputTypeText = 'text'
            document.getElementById(`${this.inputId}`).focus()
          }
        }
    },
    inputext: {
        handler () {
            if (this.inputext) {
                this.inputValue = this.inputext
            } else {
              this.inputValue = this.inputext
            }
        },
        deep: true
    },
    inputValue: {
        handler () {
            if (this.inputext !== this.inputValue) {
                this.inputValue = this.inputext
            }
        },
        deep: true
    },
    searchForCountry: {
     handler() {
        let filter = this.searchForCountry.toLowerCase();
        this.countryList = []
        for (let index = 0; index < this.countryMainList.length; index++) {
            if (this.searchForCountry.toLowerCase().indexOf(filter) > -1 === this.countryMainList[index].name.toLowerCase().indexOf(filter) > -1) {
                this.countryList.push(this.countryMainList[index])
            }
        }
    }
    },
  },
  mounted() {
    if (this.selectedCountry !== '') {
      this.countryCode = this.selectedCountry
    }
    this.showError = this.fieldError
    this.inputTypeText = this.inputType
    if (this.disabled) {
      this.disabledBtn = this.disabled
    }
    setTimeout(() => {
      this.inputValue = this.inputext
     }, 200);
    setTimeout(() => {
      if (this.autoFocus) {
        document.getElementById(`${this.inputId}`).focus()
      }
    }, 10);
  },
  methods: {
    showCountrylist () {
      this.showContrylist = true
      this.countryList = this.countryMainList
      setTimeout(() => {
        document.getElementById('codesearch').focus()
      }, 500);
    },
    selectNewForVal (data) {
      this.countryCode = data.dialCode
      this.$emit('selectCountry', this.countryCode)
        document.getElementById(`${this.inputId}`).focus()
    },
    isNumber (KeyboardEvent) {
      // if (this.inputType === 'number') {
        const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '+', '-', '.']
      const keyPressed = KeyboardEvent.key
      if (!keysAllowed.includes(keyPressed)) {
        KeyboardEvent.preventDefault()
      }
      // }
      this.$emit('keyPressAction')
    },
    inputChangeAction (text) {
        this.$emit('inputChangeAction', text)
    },
    change () {
        this.$emit('change')
    },
    // keyPressAction () {
    // },
    enterkeyPressAction () {
        this.$emit('enterkeyPressAction')
    },
    blurAction (value) {
        this.$emit('blurAction', value)
    },
    blurEventCountry () {
      setTimeout(() => {
        this.searchForCountry = ''
      }, 500);
    },
    focus () {
        this.$emit('focus')
    },
    onClickInputAction (event) {
      document.getElementById(`${this.inputId}`).focus()
        this.$emit('onClickInputAction')
        event.target.setSelectionRange(0, String(this.inputValue).length);
    },
    closePopup () {
      this.showContrylist = false
      this.$emit('closePopup')
    },
    keyup () {
        this.$emit('keyup')
    }
  },
};
</script>
<style scoped>
.country_box {
  top: 22px !important;
  min-height: 48px;
}
</style>
